/* eslint-disable no-param-reassign */

import { AxiosInstance } from 'axios'

import store from '../store'
import TokenUtils from '../utils/tokenUtils'
import { logout as logoutAction, refresh as refreshAction } from '../store/authSlice'

const registerInterceptors = (instance: AxiosInstance): void => {
  instance.interceptors.request.use((config) => {
    config.headers['Accept-Language'] = 'is'

    if ('requireAuth' in config && config.requireAuth === false) {
      return config
    }

    const { authToken, authTokenData } = store.getState().auth

    if (TokenUtils.isAccessTokenExpired(authTokenData)) {
      return new Promise((resolve, reject) => {
        store.dispatch(logoutAction()).finally(() => {
          window.location.href = '/login?loggedOut=true'
          reject(new Error('exp'))
        })
      })
    }

    if (TokenUtils.willAccessTokenExpireSoon(authTokenData)) {
      const originalRequest = config

      return new Promise((resolve, reject) => {
        store
          .dispatch(refreshAction())
          .then((token) => {
            config.headers.common.Authorization = `Bearer ${token}`
            resolve(originalRequest)
          })
          .catch((e) => {
            reject(e)
          })
      })
    }

    config.headers.common.Authorization = `Bearer ${authToken}`

    return config
  })
}

export default registerInterceptors
